<div class="host-note-v2">
  <div class="content flex flex-row" [formGroup]="form">
    <div class="v4-layout-form v4-layout-form-vertical flex-1 pr-8">
      <!-- 类型 -->
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">{{ "component.note.type" | translate }}</div>
        <div class="v4-layout-field-control">
          <nz-radio-group formControlName="type" (ngModelChange)="typeChange()">
            <label nz-radio [nzValue]="1">
              <span>{{ "word.income" | translate }}</span>
            </label>
            <label nz-radio [nzValue]="-1">
              <span>{{ "word.outcome" | translate }}</span>
            </label>
          </nz-radio-group>
        </div>
      </div>
      <!-- 项目 -->
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">{{ "component.note.item" | translate }}</div>
        <div class="v4-layout-field">
          <nz-select
            nzSize="large"
            nzPlaceHolder="{{ 'placeholder.outcome_item' | translate }}"
            formControlName="action_type"
            [nzOptions]="listOfItemOption"
          >
          </nz-select>
        </div>
      </div>
      <!-- 币种 -->
      <div class="v4-layout-field" *ngIf="scope === 'global'">
        <div class="v4-layout-field-label">
          {{ "component.note.currency" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <nz-select nzSize="large" formControlName="currency_type">
            <nz-option *ngFor="let currency of currencyList" [nzLabel]="currency" [nzValue]="currency"></nz-option>
          </nz-select>
        </div>
      </div>
      <!-- 金额 -->
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">
          {{ "component.note.amount" | translate }}
          <span *ngIf="scope === 'order'">
            {{ currencyType }}
          </span>
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <host-input-with-error
              class="w-full"
              [showError]="checking && (!form.get('amount').value || form.get('amount').value === '')"
              errorText="{{ 'errorText.fee_required' | translate }}"
            >
              <nz-input-number
                nzSize="large"
                [nzStep]="1"
                [nzMin]="0"
                [nzPrecision]="2"
                [nzPlaceHolder]="amountPlaceHolder"
                formControlName="amount"
              >
              </nz-input-number>
            </host-input-with-error>
          </div>
        </div>
      </div>
      <!-- 交易方式 -->
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">
          {{ "component.note.payment_method" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <host-input-with-error
            class="w-full"
            [showError]="checking && form.get('payment_method').value === null"
            errorText="{{ 'errorText.choose_transaction_method' | translate }}"
          >
            <nz-select
              nzSize="large"
              nzPlaceHolder="{{ 'placeholder.payment_method' | translate }}"
              formControlName="payment_method"
              [nzOptions]="listOfMethodOption"
            >
            </nz-select>
          </host-input-with-error>
        </div>
      </div>
      <!-- 相关房间 -->
      <div class="v4-layout-field" *ngIf="scope === 'global'">
        <div class="v4-layout-field-label">
          {{ "component.note.related_house" | translate }}
        </div>

        <div class="v4-layout-field-control">
          <v4-house-select
            size="large"
            formControlName="house_ids"
            [mode]="isOutcomeType && type === 'create' ? 'multi' : 'single'"
          ></v4-house-select>
        </div>
      </div>
    </div>
    <div class="v4-layout-form v4-layout-form-vertical flex-1 pl-8">
      <!-- 时间分摊 -->
      <div class="v4-layout-field" *ngIf="isOutcomeType && type === 'create' && scope === 'global'">
        <div class="v4-layout-field-label">
          {{ "component.note.time_sharing" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <nz-radio-group formControlName="share">
            <label nz-radio [nzValue]="'no'">
              {{ "component.note.no_time_sharing" | translate }}
            </label>
            <label nz-radio [nzValue]="'month'">
              {{ "component.note.monthly_share" | translate }}
            </label>
          </nz-radio-group>
        </div>
      </div>
      <!-- 分摊月份 -->
      <div class="v4-layout-field" *ngIf="isShareMonth">
        <div class="v4-layout-field-label">
          {{ "component.note.share_months" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <host-input-with-error
            class="w-full"
            [showError]="checking && !form.get('month_share').value"
            errorText="{{ 'errorText.choose_date_required' | translate }}"
          >
            <nz-range-picker nzSize="large" nzMode="month" formControlName="month_share"></nz-range-picker>
          </host-input-with-error>
        </div>
      </div>
      <!-- 交易时间 -->
      <div class="v4-layout-field">
        <ng-container *ngIf="!isShareMonth">
          <div class="v4-layout-field-label">
            {{ "component.note.time" | translate }}
          </div>

          <div class="v4-layout-field-control">
            <nz-date-picker
              nzSize="large"
              formControlName="action_date"
              [nzFormat]="angularDateFormat"
              [nzShowTime]="true"
              [nzAllowClear]="false"
            ></nz-date-picker>
          </div>
        </ng-container>

        <ng-container *ngIf="isShareMonth">
          <div class="v4-layout-field-label">
            {{ "component.note.moment" | translate }}
          </div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <div class="flex-1 pr-2">
                <nz-select nzSize="large" formControlName="action_day" [nzOptions]="listOfDayOption">
                  <!-- <nz-option *ngFor="let day of dayList" [nzLabel]="day.title" [nzValue]="day.id"></nz-option> -->
                </nz-select>
              </div>
              <div class="flex-1 pl-2">
                <nz-time-picker
                  nzSize="large"
                  [nzFormat]="angularTimeFormat"
                  [nzUse12Hours]="use12Hours"
                  formControlName="action_time"
                  [nzDefaultOpenValue]="defaultOpenValue"
                ></nz-time-picker>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <!-- 凭证 -->
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">
          {{ "component.note.certificate" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <host-upload-voucher formControlName="invoice_ids"></host-upload-voucher>
        </div>
      </div>
      <!-- 备注 -->
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">{{ "order.guest_remarks" | translate }}</div>
        <div class="v4-layout-field-control">
          <textarea
            rows="7"
            formControlName="note"
            nz-input
            placeholder="{{ 'placeholder.input_remarks' | translate }}"
          ></textarea>
        </div>
      </div>
    </div>
  </div>

  <div class="footer">
    <nz-alert
      *ngIf="isOutcomeType && scope === 'global'"
      nzShowIcon
      [nzMessage]="'component.note.outcome_share_info' | translate"
    ></nz-alert>

    <div *ngIf="isIncomeType || scope === 'order'"></div>
    <div class="button">
      <button nzSize="large" nz-button nzType="primary" (click)="onConfirm()">
        {{ "word.save" | translate }}
      </button>
      <button nzSize="large" nz-button (click)="cancel()">
        {{ "word.cancel" | translate }}
      </button>
    </div>
  </div>
</div>
